import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'linkifyImage',
})
export class LinkifyImagePipe implements PipeTransform {
  constructor(private _domSanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    return this._domSanitizer.bypassSecurityTrustHtml(this.linkifyImage(value));
  }

  private linkifyImage(text: string): string {
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = text;
    const arrayImg = htmlContent.getElementsByTagName('img');

    for (let i = 0; i < arrayImg.length; i++) {
      const img = arrayImg[i];
      //create anchor tag
      const anchor = document.createElement('a');
      const src = img.getAttribute('src');
      anchor.setAttribute('href', src);

      //get the binary image id
      const array = src.split('/');
      anchor.setAttribute('data-lightbox', array[array.length - 1]);
      anchor.appendChild(img.cloneNode());
      img.parentNode.replaceChild(anchor, img);
      //img.replaceWith(anchor);
      // console.log(htmlContent);
      // console.log(htmlContent.innerHTML);
    }
    return htmlContent.innerHTML;
  }
}
